import React, {useState, useEffect} from 'react';
import * as AuthService from '../../services/auth';
import {useSelector} from 'react-redux';
import {ContentHeader} from '@components';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import TableCostItem from './report/TableCostItem';
import {utils, write} from 'xlsx';
import FileSaver from 'file-saver';
import {toast} from 'react-toastify';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Card from 'react-bootstrap/Card';
import {useNavigate} from 'react-router-dom';
import StepCondition from './StepCondition';
import StepSelect from './StepSelect';
import StepSummary from './StepSummary';
import Stepper from 'react-stepper-horizontal';
import {Button, Collapse} from 'react-bootstrap';
import ClockLoader from 'react-spinners/ClockLoader';

export default function Costcenter() {
  const [error, setError] = useState('');
  const [step, setStep] = useState<number>(0);
  const [key, setKey] = useState('report');
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [show, setShow] = useState(false);
  const [showIbc, setShowIbc] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [data2, setData2] = useState<any[]>([]);
  const [data3, setData3] = useState<any[]>([]);
  const [status, setStatus] = useState<any>('approve');
  const [page, setPage] = useState(0);
  const [dropdownCompany, setDropdownCompany] = useState<any>({DATA: []});
  const [dropdownCostcenter, setDropdownCostcenter] = useState<any>({DATA: []});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [yearMonthSelect, setYearMonthSelect] = useState<any>('222401');
  const [companyIdSelect, setCompanyIdSelect] = useState<any>('');
  const [costIdSelect, setCostIdSelect] = useState<any>('');
  const [reason, setReason] = useState<any>('');

  const user = useSelector((state: any) => state.auth.currentUser);

  useEffect(() => {
    // downloadCostCenterWs('11', '943', '2023');
    downloadDropdownWs();
    downloadCrWs();
  }, []);

  const doStep = (number: number) => {
    setStep(step + number);
  };

  const doReset = () => {
    setStep(0);
    setYearMonthSelect('222401');
    setCompanyIdSelect('');
    setCostIdSelect('');
    setData([]);
    setData3([]);
  };

  const downloadCrWs = async () => {
    try {
      const show = await AuthService.downloadCrWs();
      if (show.error) toast.error(show.error);
      setShow(show.value);
    } catch (error) {}
  };

  const downloadDropdownOnlyMe = async (isme: boolean) => {
    try {
      if (isme === false) {
        await downloadDropdownWs();
      } else {
        await downloadDropdownOnlyMeWs();
      }
    } catch (error) {}
  };

  const doReCostCenter = async () => {
    setLoading2(true);
    try {
      let errors = '';
      let formIsValid = true;

      if (data3.filter((e) => e.select).length === 0) {
        formIsValid = false;
        errors = errors + 'ท่านไม่ได้เลือกงบคงเหลือ, ';
      }
      if (yearMonthSelect === '222401') {
        formIsValid = false;
        errors = errors + 'ท่านไม่ได้เลือกเดือนปลายทาง, ';
      }
      if (companyIdSelect === '') {
        formIsValid = false;
        errors = errors + 'ท่านไม่ได้เลือกบริษัท, ';
      }
      if (costIdSelect === '') {
        formIsValid = false;
        errors = errors + 'ท่านไม่ได้เลือก costcenter, ';
      }
      if (reason === '') {
        formIsValid = false;
        errors = errors + 'กรุณากรอกเหตุผล, ';
      }

      if (!formIsValid) setError(`Required: ${errors}`);
      if (formIsValid) {
        setError('');
        const insert = await AuthService.insertReCostcenter({
          company_id: companyIdSelect.toString(),
          cost_id: costIdSelect.toString(),
          reason: reason.toString(),
          year_month: yearMonthSelect.toString(),
          budget: data3.filter((e) => e.select)
        });
        if (insert.status) toast.success(insert.message);
        navigate('/trip-me');
      }
    } catch (error) {}
    setLoading2(false);
  };

  const downloadDropdownOnlyMeWs = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdownCarOnlyMe();
      console.log(dropdowns);
      if (dropdowns.error) throw 'timeout';
      if (Object.keys(dropdowns).length !== 0) {
        setDropdownCostcenter(dropdowns.COSTCENTER);
        setDropdownCompany(dropdowns.COMPANY);
      } else {
        setDropdownCostcenter({DATA: []});
        setDropdownCompany({DATA: []});
      }
    } catch (error: any) {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const downloadDropdownWs = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdownCar(user.ID_EMP);
      if (dropdowns.error) throw 'timeout';
      if (Object.keys(dropdowns).length !== 0) {
        setDropdownCostcenter(dropdowns.COSTCENTER);
        setDropdownCompany(dropdowns.COMPANY);
      } else {
        setDropdownCostcenter({DATA: []});
        setDropdownCompany({DATA: []});
      }
    } catch (error: any) {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const doApprove = async () => {
    try {
      const insert = await AuthService.insertApvCostcenter(costIdSelect, {
        company_id: companyIdSelect.toString(),
        year_month: yearMonthSelect,
        apv_status: 'approve'
      });
      if (insert.status) toast.success(insert.message);
      else toast.error(insert.message);
    } catch (error: any) {
      // dispatch(logoutUser());
      // window.location.href = '/login';
    }
  };

  const doReject = async () => {
    try {
      const insert = await AuthService.insertApvCostcenter(costIdSelect, {
        company_id: companyIdSelect.toString(),
        year_month: yearMonthSelect,
        apv_status: 'reject'
      });
      if (insert.status) toast.success(insert.message);
      else toast.error(insert.message);
    } catch (error: any) {
      // dispatch(logoutUser());
      // window.location.href = '/login';
    }
  };

  const downloadXlsx = () => {
    try {
      const ws = utils.json_to_sheet(data2);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, 'Sheet1');
      const wbout = write(wb, {
        bookType: 'xlsx',
        bookSST: false,
        type: 'array'
      });
      FileSaver.saveAs(
        new Blob([wbout], {type: 'application/octet-stream'}),
        `costcenter.xlsx`
      );
    } catch (err) {
      console.error('export error', err);
    }
  };

  const setPageHandle = (page: number) => {
    setPage(page);
  };

  const downloadCostCenterWs = async (
    key: string,
    companyid: string,
    costid: string,
    year: string
  ) => {
    try {
      setLoading(true);
      const costcenter = await AuthService.downloadCostCenter(
        key,
        companyid,
        costid,
        year
      );

      const _apvStatus = await downloadApvCostCenterWs(
        companyid,
        costid,
        year.toString().substring(0, 4)
        // year.substring(0, 4)
      );

      if (costcenter.error) throw 'timeout';
      if (Object.keys(costcenter).length !== 0) {
        console.log(costcenter);
        console.log(key);
        if (key === 'year') {
          setData(
            costcenter.map((e) => ({
              ...e,
              costBudget: Number(
                parseFloat(e.costBudget).toFixed(2)
              ).toLocaleString('en', {
                minimumFractionDigits: 2
              }),
              costCdsSpent: Number(
                parseFloat(e.costCdsSpent).toFixed(2)
              ).toLocaleString('en', {
                minimumFractionDigits: 2
              }),
              costCarserviceSpent: Number(
                parseFloat(e.costCarserviceSpent).toFixed(2)
              ).toLocaleString('en', {
                minimumFractionDigits: 2
              }),
              totalSpent: Number(
                parseFloat(e.totalSpent).toFixed(2)
              ).toLocaleString('en', {
                minimumFractionDigits: 2
              }),
              costRemain: Number(
                parseFloat(e.costRemain).toFixed(2)
              ).toLocaleString('en', {
                minimumFractionDigits: 2
              }),
              status: _apvStatus.some(
                (el) => el.year_month === e.month.replaceAll('-', '')
              )
                ? _apvStatus.find(
                    (el) => el.year_month === e.month.replaceAll('-', '')
                  ).apv_status
                : ''
            }))
          );

          // costcenter
          setShowIbc(costcenter.some((e) => e.empId === user.ID_EMP));
        } else {
          setData2(
            costcenter.map((e) => ({
              ...e,
              costSpent: Number(
                parseFloat(e.costSpent).toFixed(2)
              ).toLocaleString('en', {
                minimumFractionDigits: 2
              })
            }))
          );
          console.log(year);
          setStatus(
            _apvStatus.some((el) => el.year_month === year)
              ? _apvStatus.find((el) => el.year_month === year).apv_status
              : ''
          );

          setYearMonthSelect(year);
          setCompanyIdSelect(companyid);
          setCostIdSelect(costid);
        }
      } else {
        if (key === 'year') {
          setData([]);
        } else {
          setData2([]);
          console.log(year);
          console.log(_apvStatus);
          setStatus(
            _apvStatus.some((el) => el.year_month === year)
              ? _apvStatus.find((el) => el.year_month === year).apv_status
              : ''
          );

          setYearMonthSelect(year);
          setCompanyIdSelect(companyid);
          setCostIdSelect(costid);
        }
      }
      setLoading(false);
    } catch (error) {
      // dispatch(logoutUser());
      // window.location.href = '/login';
    }
  };

  const updateData3 = async (month: string, select: boolean) => {
    const _temp = data3.map((e) => {
      if (e.month === month) return {...e, select: select};
      else return e;
    });
    setData3(_temp);
  };

  const downloadCostCenterWs2 = async (
    key: string,
    companyid: string,
    costid: string,
    year: string
  ) => {
    try {
      setLoading2(true);
      const costcenter = await AuthService.downloadCostCenter(
        key,
        companyid,
        costid,
        year
      );

      if (costcenter.error) throw 'timeout';
      if (Object.keys(costcenter).length !== 0) {
        console.log(costcenter);
        console.log(key);
        if (key === 'year') {
          setData3(
            costcenter.map((e) => ({
              ...e,
              costRemain: Number(
                parseFloat(
                  (Math.round(e.costRemain / 100) * 100).toString()
                ).toFixed(2)
              ).toLocaleString('en', {
                minimumFractionDigits: 2
              }),
              select: false
            }))
          );
        }
      } else {
        if (key === 'year') {
          setData3([]);
        }
      }
      setLoading2(false);
    } catch (error) {}
  };

  const downloadApvCostCenterWs = async (
    companyid: string,
    costid: string,
    year: string
  ) => {
    let result = [];
    try {
      const costcenter = await AuthService.downloadApvCostcenter(
        costid,
        companyid,
        year
      );
      result = costcenter;
    } catch (error) {}
    return result;
  };
  return (
    <div>
      <ContentHeader title="Cost Center" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k: any) => {
                  setKey(k);
                  doReset();
                }}
                className="mb-3"
              >
                <Tab eventKey="report" title="รายงาน">
                  <TableCostItem
                    setYearMonthSelect={setYearMonthSelect}
                    yearMonthSelect={yearMonthSelect}
                    loading={loading}
                    export={downloadXlsx}
                    approve={doApprove}
                    reject={doReject}
                    cr={show}
                    ibc={showIbc}
                    show={true}
                    items={data}
                    items2={data2}
                    status={status}
                    dropdownCompany={dropdownCompany}
                    dropdownCostcenter={dropdownCostcenter}
                    downloadCostCenterWs={downloadCostCenterWs}
                    downloadDropdownOnlyMe={downloadDropdownOnlyMe}
                    onPageChange={setPageHandle}
                    page={page}
                  />
                </Tab>
                <Tab
                  eventKey="rebudget"
                  title="ขอโยกงบ"
                  // tabClassName="d-none"
                >
                  <Card>
                    <div className={loading2 ? 'overlay dark' : 'd-none'}>
                      <ClockLoader color="#c4c4c4" />
                    </div>
                    <Card.Header>
                      <Stepper
                        size={32}
                        // activeColor={'#f8f9fa'}
                        // completeColor={'#f8f9fa'}
                        // defaultColor={'#f8f9fa'}
                        titleFontSize={12}
                        circleFontSize={14}
                        steps={[
                          {title: 'เงื่อนไข'},
                          {title: 'เลือกงบคงเหลือ'},
                          {title: 'สรุป'}
                        ]}
                        activeStep={step}
                      />
                    </Card.Header>
                    <Card.Body>
                      <Collapse
                        in={step === 0}
                        timeout={1000}
                      >
                        <div
                          style={{
                            textAlign: 'justify'
                          }}
                        >
                          <StepCondition />
                        </div>
                      </Collapse>
                      <Collapse
                        in={step === 1}
                        timeout={1000}
                      >
                        <div
                          style={{
                            textAlign: 'justify'
                          }}
                        >
                          <StepSelect
                            setYearMonthSelect={setYearMonthSelect}
                            setCompanyIdSelect={setCompanyIdSelect}
                            setCostIdSelect={setCostIdSelect}
                            dropdownCompany={dropdownCompany}
                            dropdownCostcenter={dropdownCostcenter}
                            downloadCostCenterWs2={downloadCostCenterWs2}
                            data3={data3}
                            updateData3={updateData3}
                          />
                        </div>
                      </Collapse>
                      <Collapse
                        in={step === 2}
                        timeout={1000}
                      >
                        <div
                          style={{
                            textAlign: 'justify'
                          }}
                        >
                          <StepSummary
                            data3={data3}
                            yearMonthSelect={yearMonthSelect}
                            costIdSelect={costIdSelect}
                            dropdownCostcenter={dropdownCostcenter}
                            setReason={setReason}
                          />
                        </div>
                      </Collapse>
                      {/* {step === 0 ? (
                        <Fade in={step === 0} timeout={1000}>
                          <div>
                            <StepCondition />
                          </div>
                        </Fade>
                      ) : step === 1 ? (
                        <Fade in={step === 1} timeout={1000}>
                          <div>
                            <StepSelect
                              setYearMonthSelect={setYearMonthSelect}
                              setCompanyIdSelect={setCompanyIdSelect}
                              setCostIdSelect={setCostIdSelect}
                              dropdownCompany={dropdownCompany}
                              dropdownCostcenter={dropdownCostcenter}
                              downloadCostCenterWs2={downloadCostCenterWs2}
                              data3={data3}
                              updateData3={updateData3}
                            />
                          </div>
                        </Fade>
                      ) : (
                        <Fade in={step === 2} timeout={1000}>
                          <div>
                            <StepSummary
                              data3={data3}
                              yearMonthSelect={yearMonthSelect}
                              costIdSelect={costIdSelect}
                              dropdownCostcenter={dropdownCostcenter}
                              setReason={setReason}
                            />
                          </div>
                        </Fade>
                      )} */}
                    </Card.Body>
                    <Card.Footer>
                      <Button
                        className={step === 0 ? 'd-none' : 'm-2'}
                        variant="outline-secondary"
                        onClick={() => {
                          doStep(-1);
                        }}
                      >
                        ย้อนกลับ
                      </Button>
                      <Button
                        className={step === 2 ? 'd-none' : 'm-2'}
                        variant="outline-primary"
                        onClick={() => {
                          doStep(1);
                        }}
                      >
                        ถัดไป
                      </Button>
                      <Button
                        className={step === 2 ? 'm-2' : 'd-none'}
                        variant="success"
                        onClick={() => {
                          doReCostCenter();
                          // doStep(-1);
                        }}
                      >
                        ส่งขออนุมัติ
                      </Button>
                      <p className="text-danger col-md-12">{error}</p>
                    </Card.Footer>
                  </Card>
                  {/* <MultiStep activeStep={0}>
                    <StepCondition title="เงื่อนไข" />
                    <StepSelect title="เลือกรายการ"                     dropdownCompany={dropdownCompany}
                    dropdownCostcenter={dropdownCostcenter} />
                    <StepSummary title="สรุปและยืนยัน" />
                  </MultiStep> */}
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
